export default __webpack_public_path__ + "static/media/machine-imageview.173cd8c9.png";